import { useRoutes } from "react-router-dom";
 import "./App.scss";
import { AppRoutes } from "./App.Route";

const App = () => {
  return useRoutes(AppRoutes);
};

export default App;
